// Port of api/fuel/app/classes/filter/package/games/play/package/games/players/group.php
import F from 'offline/filter/constants'
export default {
	require: function(config, filter) { return config.ownerType !== F.OWNER_USER && filter.play && filter.play.group },
	run: function(pkg, local) {
		pkg.players = local.players && Object.keys(local.players).length ? local.players : []
		pkg.record = local.record || {}
		return pkg
	}
}
